import { render, staticRenderFns } from "./GroupSubmit.vue?vue&type=template&id=5e420c4d&scoped=true&"
import script from "./GroupSubmit.vue?vue&type=script&lang=js&"
export * from "./GroupSubmit.vue?vue&type=script&lang=js&"
import style0 from "./GroupSubmit.vue?vue&type=style&index=0&id=5e420c4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e420c4d",
  null
  
)

export default component.exports